import React from "react"
import BackgroundImage from "gatsby-background-image"
import { StyledTitleSection } from "./TitleSection.styled"

const TitleSection = ({ title, subtitle, bg }) => (
  <StyledTitleSection>
      <BackgroundImage
        Tag="div"
        className="title-section-bg"
        fluid={bg}
        backgroundColor="#040e18"
      />
      <div className="container">
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>
  </StyledTitleSection>
)

export default TitleSection
